<template>
  <b-row class="m-0">
    <b-col class="d-flex align-items-center px-2 p-lg-5">
        <login />
    </b-col>
    <b-col class="d-flex align-items-center px-2 p-lg-5">
      <b-card>
        <register />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import Login from "./login/Login.vue";
import Register from "./Register.vue";

export default {
  components: {
    BRow,
    BCol,
    Login,
    Register,
  },
};
</script>

<style></style>
